import {lazy} from '@aboutyou/lazy-imports';

export const LogLostScrollPosition = lazy(() =>
  import('./LogLostScrollPosition.eager').then(mod => ({
    default: mod.LogLostScrollPosition,
  })),
);
